import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/plans.svg
 */
const IconPlans: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M.002 8.286V7.15a2.486 2.486 0 012.376-2.585h19.244a2.487 2.487 0 012.376 2.585v1.135"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.998 10.234v6.615a2.488 2.488 0 01-2.376 2.585H2.378a2.488 2.488 0 01-2.376-2.585v-6.615h23.996zm-21.69 6.338a.15.15 0 01.15-.15h4.298a.15.15 0 110 .3H2.458a.15.15 0 01-.15-.15zm.15-2.36a.15.15 0 100 .3h7.489a.15.15 0 000-.3h-7.49z"
      fill="currentColor"
    />
  </svg>
);

export default IconPlans;
